import React from "react";
import styles from "./CalendarPage.module.css";
import Sidebar from "./Sidebar";
import CalendarWorkPlan from "./CalendarWorkPlan";
import { useState } from "react";

const CalendarPage = ({ objectives, onAddObjective, onDeleteObjective, updateObjectives }) => {
  const [selectedObjective, setSelectedObjective] = useState(null);

  return (
    <div className={styles.container}>
      <div className={styles.subtitle}>
        <p>
          Aquí podrás agregar tantos objetivos sean necesarios para dar ese paso
          profesional que necesitas, consúltalo cada que creas necesario.
        </p>
      </div>
      <div className={styles.content}>
        <Sidebar objectives={objectives} onAddObjective={onAddObjective} onDeleteObjective={onDeleteObjective} selectedObjective={selectedObjective} setSelectedObjective={setSelectedObjective} updateObjectives={updateObjectives}  />
        <CalendarWorkPlan objectives={objectives} selectedObjective={selectedObjective} setSelectedObjective={setSelectedObjective}  />
      </div>
    </div>
  );
};

export default CalendarPage;
